import api from './api'
import axios from 'axios'
import { authService } from './authService'
import { normalizeOssUrlForPresign } from '@/utils/ossUrl'

const uploadApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 600000,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

uploadApi.interceptors.request.use((config) => {
  if (authService.isTokenExpired()) {
    localStorage.removeItem('user')
    window.location.href = '/'
    return Promise.reject(new Error('Token已过期'))
  }
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
}, (error) => Promise.reject(error))

uploadApi.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success !== undefined) {
      return response.data
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user')
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export const therapyStoreService = {
  getStore() {
    return api.get('/therapy/store')
  },
  updateStore(payload) {
    const body = { ...payload }
    if (body.imageUrl) body.imageUrl = normalizeOssUrlForPresign(body.imageUrl)
    if (body.customerServiceQrImageUrl) {
      body.customerServiceQrImageUrl = normalizeOssUrlForPresign(body.customerServiceQrImageUrl)
    }
    if (body.officialAccountQrImageUrl) {
      body.officialAccountQrImageUrl = normalizeOssUrlForPresign(body.officialAccountQrImageUrl)
    }
    return api.put('/therapy/store', body)
  },
  uploadQrImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    return uploadApi.post('/therapy/store/images/upload', formData)
  },
  getPresignedUrl(imageUrl) {
    const clean = normalizeOssUrlForPresign(imageUrl)
    return api.get(`/therapy/store/images/presigned-url?url=${encodeURIComponent(clean)}`)
  }
}
